import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
export default class BolillaReminderNotification extends Notification {
  icon() {
    return 'fas fa-futbol';
  }
  href() {
    const season = this.attrs.notification.content() && this.attrs.notification.content().season || '2026-2027';
    return app.route('bolillaVote', {
      season
    });
  }
  content() {
    return app.translator.trans('nagusi-match-ratings.forum.notification.bolilla_reminder');
  }
  excerpt() {
    return null;
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/bolilla/BolillaReminderNotification', BolillaReminderNotification);